export default function ConfirmDeleteUser(props) {

    const cancel = () => {
        props.cancel()
    }
    const confirm = () => {
        props.confirm()
    }

    return (

        <div className="bootbox modal fade bootbox-confirm show" tabindex="-1" role="dialog" style={{paddingRight: '5px', display: 'block'}} aria-modal="true">
            <div className="modal-dialog"><div className="modal-content">
                <div className="modal-body">
                    <button onClick={props.cancel} type="button" className="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style={{marginTop: '-10px'}}>×</button>
                    <div className="bootbox-body">Are you sure you wish to delete user {props.userId}?</div>
                </div>
                <div className="modal-footer">
                    <button onClick={() => cancel()} data-bb-handler="cancel" type="button" className="btn btn-default">Cancel</button>
                    <button onClick={() => confirm()} data-bb-handler="confirm" type="button" className="btn btn-primary">OK</button>
                </div>
            </div>
            </div>
        </div>
    )

}